export const TIME_INTERVAL = {
  ONE_MINUTE: 60 * 1000,
  FIFTEEN_SECONDS: 15 * 1000,
};

export const TIME_INTERVAL_MINUTES = {
  THIRTY_MINUTES: 30,
  ONE_HOUR: 1 * 60,
  SIX_HOURS: 6 * 60,
  TWELVE_HOURS: 12 * 60,
  ONE_DAY: 24 * 60,
};
